export const hideStrikethroughPrice = (state: string) => {
  // states in which we cannot show strikethrough prices for compliance
  const restrictedStates = ['Massachusetts', 'MA'];
  return restrictedStates.includes(state);
};
